<template>
  <div style="color:#8B857D; width:100%;" class="text-center ml-3 mb-12">
    <span v-if="hasActiveSubscription">
      Subskrypcja ogólna kończy się:
      <br/>
      {{ getExpirationDate(activeSubscriptions[0].expiration_time) }}
      <p class="">
        <a  style="color:#8B857D; margin-right:10px;" @click="redirect" class="redirect-to-subscriptions"
          >Przedłuż subskrypcję ogólną</a
        >
        <svg
          width="31"
          height="16"
          viewBox="0 0 31 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
            fill="#8B857D"
          />
        </svg>
      </p>
    </span>
    <span v-else>
      <span class="sub-title" style="font-size:24px; text-align:center;">
        Subskrypcja "Szkoła online - platforma jogi online - Ogólna"</span
      >

      <p @click="redirect" style="cursor:pointer;" class="">
        <a
          style="color:#8B857D; margin-right:10px;"
          class="redirect-to-subscriptions"
          >Wykup dostęp</a
        >
        <svg
          width="31"
          height="16"
          viewBox="0 0 31 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 8V9H30V8V7H0V8Z"
            fill="#8B857D"
          />
        </svg>
      </p>
    </span>

    <!-- <span v-if="hasActiveSubscriptionExtended">
      Subskrypcja rozszerzona kończy się:
      {{ getExpirationDate(activeSubscriptionsExtended[0].expiration_time) }}
      <p class="">
        <a @click="redirect" class="redirect-to-subscriptions"
          >Przedłuż subskrypcję rozszerzoną</a
        >
      </p>
    </span>
    <span v-else>
      Subskrypcja "Szkoła online - platforma jogi online - Rozszerzona"
      <p class="">
        <a
          @click="redirectToExtendedSubscriptions"
          class="redirect-to-subscriptions"
          >Wykup dostęp</a
        >
      </p>
    </span> -->
    <div style="display:flex; align-items:center; justify-content:center;"> 
      <telegram v-if="hasActiveSubscription" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Telegram from "./Telegram.vue";
export default {
  components: { Telegram },
  async mounted() {
    await this.$store.dispatch(`auth/checkUserActiveSubscriptions`, {
      excludeFreezing: true
    });
    await this.$store.dispatch(`auth/checkUserActiveSubscriptionsExtended`);
    if (this.hasActiveSubscriptionExtended) {
      await this.$store.dispatch(
        `timePackages/fetchActiveSubscriptionsExtended`
      );
    } else {
      await this.$store.dispatch(
        `timePackages/setActiveSubscriptionsExtendedToNull`
      );
    }

    if (this.hasActiveSubscription) {
      await this.$store.dispatch(`timePackages/fetchActiveSubscriptions`);
    } else {
      await this.$store.dispatch(`timePackages/setActiveSubscriptionsToNull`);
    }
  },
  methods: {
    getExpirationDate(date) {
      return moment(date)
        .locale("pl")
        .format("DD MMMM YYYY");
    },
    redirect() {
      this.$router.push({
        name: "TimeSubscriptions",
        params: { name: "Courses" },
      });
    },
    redirectToExtendedSubscriptions() {
      if (this.$route.name === "CoursesExtended") {
        document.getElementById("buy-extended").scrollIntoView();
      } else {
        this.$router.push({
          name: "CoursesExtended",
          params: { name: "Courses" },
        });
      }
    },
  },

  computed: {
    activeSubscriptions() {
      return this.$store.getters["timePackages/getActiveSubscriptions"];
    },
    activeSubscriptionsExtended() {
      return this.$store.getters["timePackages/getActiveSubscriptionsExtended"];
    },
    hasActiveSubscription() {
      return this.$store.getters["auth/getHasActiveSubscription"];
    },
    hasActiveSubscriptionExtended() {
      return this.$store.getters["auth/getHasActiveSubscriptionExtended"];
    },
  },
};
</script>

<style scoped>
.redirect-to-subscriptions {
  color: #000;
  text-decoration: underline;
  font-size: 15px;
  font-weight: 600;
  width: fit-content;
}
</style>
